// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"Loader_loaderOverlay__+tGZ+"};